
import { defineComponent } from 'vue'
import useVuelidate from '@vuelidate/core'
import CarousselCard from '@/components/CarousselCard.vue'

export default defineComponent({
  components: {
    CarousselCard
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      active: 1,
      slides: 1
    }
  },
  computed: {
    cards(): any[] {
      return [
        {
          id: 1,
          title: this.$t('login-page.carroussel.first-card-title'),
          text: this.$t('login-page.carroussel.first-card-text'),
          imageName: 'login-prom.png'
        }
      ]
    }
  },
  methods: {
    jump(index: number) {
      this.active = index
    },
    move(amount: number) {
      let newActive
      const newIndex = this.active + amount
      if (newIndex > this.cards.length) newActive = 1
      if (newIndex === 0) newActive = this.cards.length
      this.active = newActive || newIndex
    }
  }
})
